import axios from '../axios';
import { apiPaths } from '../helper/apiPaths';
import { errMsg, errMsgNoData } from '../helper/functions';
import { AnnualReviewFeedbackHr } from '../types/AnnualFeedbackReport';
import { ErrorResponseType } from '../types';

const getAnnualFeedbackReportHrCode = import.meta.env
  .VITE_GET_ANNUAL_FEEDBACK_REPORT_HR;

export const getAnnualFeedbackReportHr = async (cycleId: string) => {
  const ret: {
    data?: AnnualReviewFeedbackHr;
    error: ErrorResponseType | null;
  } = { error: null };

  try {
    const { data } = await axios.get(
      `${apiPaths.annualFeedbackReportHr}/${cycleId}?code=${getAnnualFeedbackReportHrCode}`
    );

    if (data) ret.data = data;
    else ret.error = errMsgNoData();

    return ret;
  } catch (err) {
    ret.error = errMsg(err);
    return ret;
  }
};
